export default {
  banners:[
    // imgUrl: '图片地址'， title: '标题文本', description: '描述信息', component: '跳转组件名称'
      {
        imgUrl: require('../../../assets/images/services/banner-06.jpg'),
        title: 'BLOCKCHAIN',
        description: '',
        component: ''
      }
  ],
  items:[
    {
      title: 'ADVANCED ENCRYPTED STORAGE TECHNOLOGY',
      description: `<p style="font-size:1.5rem">Blockchain is a new computer technology, used for diverse applications such as distributed data storage, point-to-point transmission, consensus mechanism and encryption algorithm. The blockchain system is open and self-contained, changing the former ‘trust in humans’ to ‘trust in machines’. Although the blockchain system is open, the data stored in the blockchain is stable and reliable. Therefore, the new model of block chain can solve the disadvantages of traditional industries, such as logistics, finance, insurance, public networks, etc., which need a lot of complex collaborative communication, resulting in a lack of transparency and inability to subdivide the business. Blockchain technology will save time and money costs and create more benefits for your enterprises.</p>`
    },
    {
      title: 'OUR ADVANTAGE',
      description: `<span class='img' style="background:url(`+require('../../../assets/images/services/pic-06.jpg')+`)"></span>
      <span>Maesinfo explores cutting-edge blockchain technologies thanks to our
high- level research and development teams. Our many years of
computer technology service experience will be put to use to the new blockchain-based business models. We will closely integrate the development of various industries to provide blockchain integrated
solutions for enterprises and users, such as blockchain technology
services, business plan information, blockchain ecological
co-construction and so on. </span>`
    }
  ]
}
